export default "__VITE_ASSET__zw84H14q__"